import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {filterBasicTypes} from '@adv-mt/mt-filter-basic'
import FilterWrapperBasic, {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'

import {PRICE_MODE} from '../settings.js'

const filterName = 'priceRange'
const filterPriceModeName = 'priceMode'

export const PriceRangeFilter = ({isPriceModeEnabled, options, onChange, value, onPriceModeChange, priceMode}) => {
  const {i18n} = useContext(Context)
  const [selectedPriceRangeOption, setSelectedPriceRangeOption] = useState(value?.id ? [value.id] : [])
  const [selectedPriceModeOption, setSelectedPriceModeOption] = useState(priceMode)

  const _handleOnChange = item => {
    if (item.name === filterPriceModeName) {
      const [newPriceMode] = item.value
      setSelectedPriceModeOption(item.value)
      return onPriceModeChange(newPriceMode)
    }
    if (item.name === filterName) {
      const [selectedId] = item.value
      setSelectedPriceRangeOption(item.value)
      const _option = options.find(option => option.id === selectedId)
      return onChange(_option)
    }
  }

  const filters = [
    ...(isPriceModeEnabled
      ? [
          {
            name: filterPriceModeName,
            options: [
              {id: PRICE_MODE.INSTALLMENT, label: i18n.t('COMMON.FEE')},
              {id: PRICE_MODE.FULL_PRICE, label: i18n.t('COMMON_CASH')}
            ],
            type: filterBasicTypes.BUTTON_GROUP_SINGLE_SELECTION
          }
        ]
      : []),
    {
      name: filterName,
      options,
      type: filterBasicTypes.SINGLE_SELECTION_OUTLINED
    }
  ]

  return (
    <div className="mt-VehicleSuggester-column">
      <FilterWrapperBasic
        filters={filters}
        group={`${filterName}Group`}
        legend={i18n.t('COMMON.BUDGET')}
        onChange={_handleOnChange}
        value={{[filterName]: selectedPriceRangeOption, [filterPriceModeName]: [selectedPriceModeOption]}}
        wrapper={filterWrapperBasicTypes.NONE}
      />
    </div>
  )
}

PriceRangeFilter.propTypes = {
  isPriceModeEnabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onPriceModeChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  priceMode: PropTypes.string.isRequired,
  value: PropTypes.object
}
